<app-pageheader [Parent]="this">
  <add-button AddRoute="/valet/stations/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="valet/stations/searches"
  [AllowEdit]="true" EditUrl="/valet/stations/:id" [UseQueryParamStates]="true">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>
